import { render, staticRenderFns } from "./UploadK1Modal.vue?vue&type=template&id=2f15d332&scoped=true&"
import script from "./UploadK1Modal.vue?vue&type=script&lang=ts&"
export * from "./UploadK1Modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15d332",
  null
  
)

export default component.exports